(function(window, quizControllerFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.quizController = quizControllerFactory(
      window,
      window.$,
      window.Q,
      namespace.localizationStrings,
      namespace.deviceInfo,
      namespace.QuestionSetView,
      namespace.questionSetConfirmationView,
      namespace.QuizSetupView,
      namespace.reviewAnswersConfirmationView,
      namespace.quizService,
      namespace.questionType,
      namespace.playerConfiguration,
      namespace.progressTracker,
      namespace.questionGrader,
      namespace.fathomGrader,
      namespace.xmpGrader,
      namespace.questionSetReviewStatusView,
      namespace.events,
      namespace.urlService,
      namespace.hotkeyService,
      namespace.scormController,
      namespace.statusCodes,
      namespace.messageBarType,
      namespace.MessageBarView);
})(this, function(window,
                  $,
                  Q,
                  localizationStrings,
                  deviceInfo,
                  QuestionSetView,
                  questionSetConfirmationView,
                  QuizSetupView,
                  reviewAnswersConfirmationView,
                  quizService,
                  questionType,
                  playerConfiguration,
                  progressTracker,
                  questionGrader,
                  fathomGrader,
                  xmpGrader,
                  questionSetReviewStatusView,
                  events,
                  urlService,
                  hotkeyService,
                  scormController,
                  statusCodes,
                  messageBarType,
                  MessageBarView) {
   'use strict';

   /**
    * @memberof TSC
    * @class quizController
    * @classdesc Quiz Controller manages questions state and views.
    */
   var _smartPlayerElement = null;
   var _quizSetupView = null;
   var _currentView = null;
   var _$container = null;
   var _quizModel = null;
   var _retrySubmissionMessageDisplayBar = null;

   var _numberQuestionSets = 0;
   var _currentQuestionSetIndex = 0;
   var _bottomPadding = 14;
   var _bottomOffset = 0;
   var _pointAt = null;
   var _quizEnabled = true;
   var _quizReady = false;
   var _enforceLinearAssessment = true;
   var _getVideoEl = null;
   var _mediaIsImage = false;
   var _lastStatusMessage = '';
   var _questionGrader;

   var submitToLMS = function() {
      if (_quizModel.useScorm) {
         // Built in Scorm support
         if (scormController.initialized) {
            scormController.submitScore(_quizModel.getScormScore(), _quizModel.isLastQuestionComplete());
         // Legacy Scorm support
         } else if (typeof window.userSubmitToLMS !== 'undefined') {
            window.userSubmitToLMS(_quizModel.getScormScore());
         }
      }
   };

   var completeQuestionSetEventDispatch = function() {
      _$container.trigger(events.Quizzing.Complete);
      hotkeyService.enableHotkeys();
   };

   var questionSetCompleteHandler = function() {
      _currentQuestionSetIndex = -1;
      _currentView.removeView(true);
      _currentView = null;
      completeQuestionSetEventDispatch();
   };

   var dispatchStatusEvent = function(ioMessage) {
      _lastStatusMessage = ioMessage;
      _$container.trigger(events.Quizzing.Status, {message: ioMessage});
   };

   var onContinueHandler = function() {
      _$container.off(events.Quizzing.CloseQuestionSetView, onContinueHandler);
      questionSetCompleteHandler();
   };

   var createQuestionSetFeedbackView = function(needOverlay) {
      var questionSetView = QuestionSetView.create(_$container, _quizModel.questionSets[_currentQuestionSetIndex], needOverlay, _mediaIsImage, true);
      _$container.on(events.Quizzing.CloseQuestionSetView, onContinueHandler);

      _currentView = questionSetView;

      updateViewBottom();

      if (_pointAt !== null) {
         _currentView.pointAt(_pointAt);
      }

      _currentView.showView();
      _currentView.updateViewPosition();
   };

   var continueVideoHandler = function() {
      $(reviewAnswersConfirmationView.getContinueControlRef()).unbind('click', continueVideoHandler);
      $(reviewAnswersConfirmationView.getReviewControlRef()).unbind('click', initQuestionSetFeedback);

      reviewAnswersConfirmationView.removeView(true);
      _currentView = null;
      completeQuestionSetEventDispatch();
   };

   var initQuestionSetFeedback = function() {
      $(reviewAnswersConfirmationView.getContinueControlRef()).unbind('click', continueVideoHandler);
      $(reviewAnswersConfirmationView.getReviewControlRef()).unbind('click', initQuestionSetFeedback);

      reviewAnswersConfirmationView.removeView(false);
      _currentView = null;
      createQuestionSetFeedbackView();
   };

   var createReviewAnswersConfirmationView = function() {
      var numberCorrectText = null;
      var percentCorrectText = null;
      var numberIncorrectText = null;
      var percentIncorrectText = null;
      var numberCorrect = 0;
      var numberIncorrect = 0;
      var numberUngradable = 0;
      var possibleCorrect = _quizModel.questionSets[_currentQuestionSetIndex].numberGradedQuestions;

      if (possibleCorrect > 0) {
         numberCorrect = _quizModel.questionSets[_currentQuestionSetIndex].numberCorrectQuestions;
         numberIncorrect = possibleCorrect - numberCorrect;
         numberUngradable = _quizModel.questionSets[_currentQuestionSetIndex].numberUngradedQuestions;

         numberCorrectText = localizationStrings.strings.txtCorrect.replace('{{numberCorrect}}', numberCorrect);
         percentCorrectText = Math.round(100 * (numberCorrect / possibleCorrect)) + '%';
         numberIncorrectText = localizationStrings.strings.txtIncorrect.replace('{{numberIncorrect}}', numberIncorrect);
         percentIncorrectText = Math.round(100 * (numberIncorrect / possibleCorrect)) + '%';
      }

      if (numberUngradable === 1) {
         questionSetReviewStatusView.setUngradeableDetails(numberUngradable + localizationStrings.strings.accessBtnWasNotGraded);
      } else {
         questionSetReviewStatusView.setUngradeableDetails(numberUngradable + localizationStrings.strings.accessBtnWereNotGraded);
      }

      var markup = reviewAnswersConfirmationView.getViewMarkup(
         numberCorrectText,
         percentCorrectText,
         numberIncorrectText,
         percentIncorrectText,
         localizationStrings.strings.txtContinue,
         localizationStrings.strings.txtReviewAnswer);

      // add view template
      _$container.append(markup);

      _currentView = reviewAnswersConfirmationView;

      $(_currentView.getContinueControlRef()).bind('click', continueVideoHandler);
      $(_currentView.getReviewControlRef()).bind('click', initQuestionSetFeedback);

      // fade in view
      _currentView.showView();
      updateViewBottom();
      if (_pointAt !== null) {
         _currentView.pointAt(_pointAt);
      }
   };

   var createQuestionSetReviewStatusView = function() {
      var numberCorrect = _quizModel.questionSets[_currentQuestionSetIndex].numberCorrectQuestions;
      var possibleCorrect = _quizModel.questionSets[_currentQuestionSetIndex].numberGradedQuestions;
      var numberUngradable = _quizModel.questionSets[_currentQuestionSetIndex].numberUngradedQuestions;

      questionSetReviewStatusView.setGradeableDetails(numberCorrect + localizationStrings.strings.accessBtnCorrectOutOf + possibleCorrect + localizationStrings.strings.accessBtnGradedQuestions);
      if (numberUngradable === 1) {
         questionSetReviewStatusView.setUngradeableDetails(numberUngradable + localizationStrings.strings.accessBtnWasNotGraded);
      } else {
         questionSetReviewStatusView.setUngradeableDetails(numberUngradable + localizationStrings.strings.accessBtnWereNotGraded);
      }

      var markup = questionSetReviewStatusView.getViewMarkup();

      _$container.append(markup);

      _currentView = questionSetReviewStatusView;

      $(questionSetReviewStatusView.getHideAnswersControlRef()).bind('click', hideQuizStatus);
      $(questionSetReviewStatusView.getShowAnswersControlRef()).bind('click', initFeedbackFromReviewStatusView);

      questionSetReviewStatusView.showView();
      _currentView.updateViewPosition();
   };

   var initFeedbackFromReviewStatusView = function() {
      $(questionSetReviewStatusView.getHideAnswersControlRef()).unbind('click', hideQuizStatus);
      $(questionSetReviewStatusView.getShowAnswersControlRef()).unbind('click', initFeedbackFromReviewStatusView);

      questionSetReviewStatusView.removeView(false);
      _currentView = null;
      createQuestionSetFeedbackView();
   };

   var hideQuizStatus = function() {
      _$container.trigger(events.Quizzing.HideQuiz);
      _currentView.hideView();
   };

   var onRationaleActionHandler = function(e, data) {
      if (e.type === events.Quizzing.RationaleActionLocation) {
         urlService.openUrl(data.location, '_blank');
      } else if (e.type === events.Quizzing.RationaleActionJumpToTime) {
         _$container.off(events.Quizzing.CloseQuestionSetView, onCloseQuestionSetView);
         _$container.off(events.Quizzing.SubmitQuestionSet, onSubmit);
         _$container.off(events.Quizzing.RationaleActionLocation, onRationaleActionHandler);
         _$container.off(events.Quizzing.RationaleActionJumpToTime, onRationaleActionHandler);

         questionSetCompleteHandler();
      }
   };

   var onCloseQuestionSetView = function() {
      _$container.off(events.Quizzing.CloseQuestionSetView, onCloseQuestionSetView);
      _$container.off(events.Quizzing.SubmitQuestionSet, onSubmit);
      _$container.off(events.Quizzing.RationaleActionLocation, onRationaleActionHandler);
      _$container.off(events.Quizzing.RationaleActionJumpToTime, onRationaleActionHandler);

      _$container.trigger(events.Quizzing.Submitted);

      if (_quizModel.questionSets[_currentQuestionSetIndex].displayFeedback) {
         if (_mediaIsImage) {
            _$container.trigger(events.Quizzing.TransitionImageQuizToAnswers);
            _currentView.removeView(true);
            createQuestionSetReviewStatusView();
         } else {
            _currentView.removeView(false);
            createReviewAnswersConfirmationView();
         }
      } else {
         questionSetCompleteHandler();
      }
   };

   var submitResults = function() {
      dispatchStatusEvent(localizationStrings.strings.txtSubmittingAnswers);

      if (_quizModel.useQuizApi) {
         var data = _quizModel.getApiDataForQuestionSet(_currentQuestionSetIndex);
         return quizService.submitQuestionSet(data).progress(function() {
            _$container.trigger(events.Quizzing.ShowSubmissionRetryMessage);
         }).then(function(results) {
            _$container.trigger(events.Quizzing.HideSubmissionRetryMessage);

            if (!_questionGrader.doesLocalGrading && results === undefined) {
               return Q.reject('Failed to get results for question set submission');
            }

            return results;
         });
      }
      return Q();
   };

   var gradeResults = function(results) {
      if (!_questionGrader.doesLocalGrading && results) {
         _questionGrader.processQuestionSetResults(_quizModel.questionSets[_currentQuestionSetIndex], results);
      } else {
         _questionGrader.gradeQuestionSet(_quizModel.questionSets[_currentQuestionSetIndex]);
      }
      return Q();
   };

   var onGradingComplete = function() {
      if (_quizModel.useScorm) {
         submitToLMS();
      }

      if (_quizModel.questionSets[_currentQuestionSetIndex].usesRationale) {
         _$container.trigger(events.Quizzing.HideLoadingMessage);
         _currentView.showFeedbackForCurrentQuestion();
      } else {
         onCloseQuestionSetView();
      }
   };

   var onSubmit = function() {
      submitResults().then(gradeResults).then(onGradingComplete).catch(apiErrorEventHandler);
   };

   var createQuestionSetView = function(needOverlay) {
      var questionSetView = QuestionSetView.create(_$container, _quizModel.questionSets[_currentQuestionSetIndex], needOverlay, _mediaIsImage, false);

      if (_quizModel.questionSets[_currentQuestionSetIndex].usesRationale) {
         _$container.on(events.Quizzing.SubmitQuestionSet, onSubmit);
         _$container.on(events.Quizzing.CloseQuestionSetView, onCloseQuestionSetView);
         _$container.on(events.Quizzing.RationaleActionLocation, onRationaleActionHandler);
         _$container.on(events.Quizzing.RationaleActionJumpToTime, onRationaleActionHandler);
      } else {
         _$container.on(events.Quizzing.SubmitQuestionSet, onSubmit);
      }

      _currentView = questionSetView;

      updateViewBottom();

      if (_pointAt !== null) {
         _currentView.pointAt(_pointAt);
      }

      _currentView.showView();
      _currentView.updateViewPosition();
   };

   var reviewHandler = function() {
      _currentView.removeView(true);
      _currentView = null;

      _$container.trigger(events.Quizzing.Review);
      hotkeyService.enableHotkeys();
   };

   var onViewRemove = function() {
      if (_currentQuestionSetIndex < _numberQuestionSets) {
         createQuestionSetView(false);
      }
   };

   var confirmHandler = function() {
      _currentView.removeView();
      _currentView = null;
      onViewRemove();
   };

   var createConfirmView = function() {
      var reviewText;

      if (_enforceLinearAssessment) {
         reviewText = localizationStrings.strings.txtReview;
      } else {
         reviewText = localizationStrings.strings.txtContinue;
      }

      var markup = questionSetConfirmationView.getViewMarkup(reviewText, localizationStrings.strings.txtAnswerQuestion);
      _$container.append(markup);

      _currentView = questionSetConfirmationView;

      updateViewBottom();

      if (_quizModel.hideReplay === true) {
         $(questionSetConfirmationView.getReviewControlRef()).hide();
      }

      $(questionSetConfirmationView.getReviewControlRef()).bind('click', reviewHandler);
      $(questionSetConfirmationView.getConfirmControlRef()).bind('click', confirmHandler);

      questionSetConfirmationView.showView();
      questionSetConfirmationView.updateViewPosition();
   };

   var destroyQuizSetupView = function() {
      if (_quizSetupView) {
         _smartPlayerElement.off(events.Quizzing.BeginClicked, beginQuizHandler);
         _smartPlayerElement.off(events.Quizzing.SkipClicked, skipQuizHandler);
         _quizSetupView.destroy();
         if (_quizSetupView.$view) {
            _quizSetupView.$view.remove();
         }
         _quizSetupView = null;
      }
   };

   var beginQuizHandler = function(event, eventData) {
      event.preventDefault();

      destroyQuizSetupView();

      _$container.trigger(events.Quizzing.SubmittingInstance);

      if (_quizModel.useQuizApi) {
         startQuizApiInstance(eventData.firstName, eventData.lastName, eventData.email);
      }

      _$container.trigger(events.Quizzing.Begin);
   };

   var skipQuizHandler = function(e) {
      e.preventDefault();
      _quizEnabled = false;

      destroyQuizSetupView();

      _$container.trigger(events.Quizzing.Skip);
   };

   var createSetupView = function() {
      _quizSetupView = QuizSetupView.create(_$container, _smartPlayerElement);

      _smartPlayerElement.on(events.Quizzing.BeginClicked, beginQuizHandler);

      if (_quizModel.allowSkipQuiz) {
         _smartPlayerElement.on(events.Quizzing.SkipClicked, skipQuizHandler);
      } else {
         _quizSetupView.hideSkipButton();
      }
   };

   var updateViewBottom = function() {
      if (_currentView && _currentView.setBottomOffset) {
         _currentView.setBottomOffset(_bottomOffset);
         _currentView.updateViewPosition();
      }
   };

   var startQuizApiInstance = function(firstName, lastName, email) {
      if (_quizModel) {
         _$container.trigger(events.Quizzing.ShowQuizBar);
         _quizReady = true;
         _$container.trigger(events.Quizzing.Begin);

         return quizService.startQuizInstance(_quizModel, firstName, lastName, email, playerConfiguration).catch(function(data) {
            apiErrorEventHandler();
            return Q.reject(data);
         });
      }

      return Q();
   };

   var apiErrorEventHandler = function(response) {
      _quizEnabled = false;
      _$container.trigger(events.Quizzing.HideLoadingMessage);
      if (response && response.status === statusCodes.UnprocessableEntity) {
         _$container.trigger(events.Quizzing.QuizIsOutOfDate);
      } else {
         _$container.trigger(events.Quizzing.Error);
      }
   };

   var displaySetupView = function() {
      return _quizModel && _quizModel.quizID && _quizEnabled && _quizModel.requireUserId && !playerConfiguration.getIsUserIdentified();
   };

   var init = function(spElement, enforceLinearAssessment, videoFunc) {
      _smartPlayerElement = spElement;
      _enforceLinearAssessment = enforceLinearAssessment;
      _getVideoEl = videoFunc;

      if (_quizModel.useQuizApi) {
         if (_quizModel.requireUserId && !playerConfiguration.getIsUserIdentified() && !playerConfiguration.ignoreQuizQuestions) {
            createSetupView();
         } else {
            startQuizApiInstance();
         }
      } else {
         _quizReady = true;
         _$container.trigger(events.Quizzing.Begin);
      }
   };

   var simpleInit = function() {
      if (!displaySetupView()) {
         startQuizApiInstance();
      }
   };

   var setSmartplayerElement = function($spElement) {
      _smartPlayerElement = $spElement;
   };

   var gatherSetupIfNeeded = function() {
      if (displaySetupView()) {
         createSetupView();
      }
   };

   var getLastStatusMessage = function() {
      return _lastStatusMessage;
   };

   var removeSubmissionRetryMessage = function() {
      if (_retrySubmissionMessageDisplayBar === null) {
         return;
      }
      _retrySubmissionMessageDisplayBar.remove();
      _retrySubmissionMessageDisplayBar = null;
   };

   var showSubmissionRetryMessage = function() {
      if (_retrySubmissionMessageDisplayBar !== null) {
         return;
      }
      _retrySubmissionMessageDisplayBar = MessageBarView.create(_$container, messageBarType.info, localizationStrings.strings.txtQuizErrorMessage);
   };

   var showQuizIsOutOfDateMessage = function() {
      MessageBarView.create(_$container, messageBarType.warning, localizationStrings.strings.txtQuizOutOfDateMessage, localizationStrings.strings.txtQuizOutOfDateRefreshButtonText, function() {
         window.location.reload();
      });
   };

   var setViewContainer = function($container) {
      _$container = $container;
      _$container.on(events.Quizzing.ShowSubmissionRetryMessage, showSubmissionRetryMessage);
      _$container.on(events.Quizzing.HideSubmissionRetryMessage, removeSubmissionRetryMessage);
      _$container.on(events.Quizzing.QuizIsOutOfDate, showQuizIsOutOfDateMessage);
   };

   var displayNextQuestionSet = function() {
      if (_currentQuestionSetIndex < _numberQuestionSets) {
         createQuestionSetView(true);
      }
   };

   var hasMultipleQuestionSets = function() {
      return _numberQuestionSets > 1;
   };

   var findQuestionSet = function(time) {
      var activeQuestionSetId = -1;
      var markerTime = -1;

      if (!playerConfiguration.ignoreQuizQuestions) {
         var markers = _quizModel.questionSetMarkerTimes;
         var numberMarkers = markers.length;

         for (var i = 0; i < numberMarkers; i++) {
            if (!markers[i].completed && (_enforceLinearAssessment && markers[i].startTime <= time && !markers[i].canSeekPast || markers[i].rangeStart <= time && time <= markers[i].rangeEnd)) {
               activeQuestionSetId = markers[i].questionSetIndex;
               markerTime = markers[i].startTime;
               break;
            }
         }
      }

      return {id: activeQuestionSetId, markerTime: markerTime};
   };

   var findPrevMarkerTimeForMarker = function(questionSetIndex) {
      return _quizModel.getPreviousMarkerTimeForMarker(questionSetIndex);
   };

   var updatePercentWatchedForQuestionSet = function(questionSetId, percentWatched) {
      _quizModel.questionSets[questionSetId].percentOfVideoSegmentWatched = percentWatched;
   };

   var displayConfirm = function(questionSetIndex) {
      if (!_currentView) {
         _currentQuestionSetIndex = questionSetIndex;

         hotkeyService.disableHotkeys();

         // no need to display confirm view if we are in the beginning of the video and force linear is on or if we are in the middle of a rationale quiz
         if (_enforceLinearAssessment && _quizModel.questionSets[questionSetIndex].startTime <= _quizModel.minMarkerTimeDiff || _quizModel.questionSets[questionSetIndex].inProgress) {
            createQuestionSetView(true);
         } else {
            createConfirmView();
         }
      }
   };

   var showQuiz = function() {
      if (_currentView === null) {
         createQuestionSetView(true);
      } else {
         _currentView.showView();
      }
   };

   var hideQuiz = function() {
      _currentView.hideView();
   };

   var pointViewAt = function(xPos) {
      _pointAt = xPos;
      if (_currentView) {
         if (_currentView.pointAt) {
            _currentView.pointAt(_pointAt);
         }
         updateViewBottom();
      }
   };

   var setViewControlBarOffset = function(bottom) {
      _bottomOffset = bottom + _bottomPadding;
      updateViewBottom();
   };

   var setQuestionGrader = function(grader) {
      switch (grader) {
         case questionGrader.FATHOM:
            {
               _questionGrader = fathomGrader;
               break;
            }
         case questionGrader.XMP:
            {
               _questionGrader = xmpGrader;
               break;
            }
         default:
            throw new Error('Grader type not recognized');
      }
   };

   var startTrackingProgress = function() {
      return quizService.getAnalyticsRate().then(function(rate) {
         progressTracker.start(_getVideoEl(), rate);
         return Q();
      });
   };

   var forceProgressUpdate = function(sampleRateInMilliseconds, segmentsCompleted) {
      return quizService.sendProgress(sampleRateInMilliseconds, segmentsCompleted);
   };

   var reset = function() {
      destroyQuizSetupView();

      if (_currentView) {
         _currentView.removeView(true);
         _currentView = null;
      }

      if (_$container) {
         _$container.off(events.Quizzing.ShowSubmissionRetryMessage, showSubmissionRetryMessage);
         _$container.off(events.Quizzing.HideSubmissionRetryMessage, removeSubmissionRetryMessage);
         _$container.off(events.Quizzing.QuizIsOutOfDate, showQuizIsOutOfDateMessage);
         _$container.off(events.Quizzing.SubmitQuestionSet, onSubmit);
         _$container.off(events.Quizzing.CloseQuestionSetView, onCloseQuestionSetView);
         _$container.off(events.Quizzing.RationaleActionLocation, onRationaleActionHandler);
         _$container.off(events.Quizzing.RationaleActionJumpToTime, onRationaleActionHandler);
         _$container = null;
      }

      removeSubmissionRetryMessage();

      _smartPlayerElement = null;
      _quizModel = null;

      _numberQuestionSets = 0;
      _currentQuestionSetIndex = 0;
      _bottomPadding = 14;
      _bottomOffset = 0;
      _pointAt = null;
      _quizEnabled = true;
      _quizReady = false;
      _enforceLinearAssessment = true;
      _getVideoEl = null;
      _mediaIsImage = false;
      _lastStatusMessage = '';
      _questionGrader = null;
   };

   var populateQuizModel = function(suspendedQuizData) {
      _quizModel.populateQuiz(suspendedQuizData);
   };

   return Object.defineProperties({
      reset: reset,
      init: init,
      simpleInit: simpleInit,
      hasMultipleQuestionSets: hasMultipleQuestionSets,
      gatherSetupIfNeeded: gatherSetupIfNeeded,
      setSmartplayerElement: setSmartplayerElement,
      getLastStatusMessage: getLastStatusMessage,
      displayNextQuestionSet: displayNextQuestionSet,
      findQuestionSet: findQuestionSet,
      findPrevMarkerTimeForMarker: findPrevMarkerTimeForMarker,
      updatePercentWatchedForQuestionSet: updatePercentWatchedForQuestionSet,
      setViewContainer: setViewContainer,
      displayConfirm: displayConfirm,
      showQuiz: showQuiz,
      hideQuiz: hideQuiz,
      pointViewAt: pointViewAt,
      setViewControlBarOffset: setViewControlBarOffset,
      startTrackingProgress: startTrackingProgress,
      setQuestionGrader: setQuestionGrader,
      forceProgressUpdate: forceProgressUpdate,
      populateQuizModel: populateQuizModel
   }, {
      quizEnabled: {
         get: function() {
            return _quizEnabled;
         },
         set: function(value) {
            _quizEnabled = value;
         }
      },
      quizReady: {
         get: function() {
            return _quizReady;
         }
      },
      hasQuiz: {
         get: function() {
            return _quizModel && _quizModel.quizID;
         }
      },
      viewIsOpen: {
         get: function() {
            return _currentView !== null;
         }
      },
      mediaIsImage: {
         set: function(mediaIsImage) {
            _mediaIsImage = mediaIsImage;
         }
      },
      quizModel: {
         get: function() {
            return _quizModel;
         },
         set: function(quizModel) {
            _quizModel = quizModel;
            _numberQuestionSets = _quizModel.numberQuestionSets;
            scormController.quizModel = _quizModel;
         }
      }
   });
});
